import { IDocumentModel, IMappingModel, IQuestionnaireModel } from "../tsmodels/QuestionnaireModel";

export const questionnaireData: IQuestionnaireModel[] = [
  {
    questionnaireId: "1",
    questionnaireName: "TSYS Application",
    createAt: "05/13/23",
    lastModifiedAt: "07/21/24",
    categories: 6,
    questions: 84,
    documents: 32,
    mappingId: undefined
  },
  {
    questionnaireId: "2",
    questionnaireName: "General Application",
    createAt: "01/04/24",
    lastModifiedAt: "07/21/24",
    categories: 4,
    questions: 47,
    documents: 16,
    mappingId: undefined
  },
  {
    questionnaireId: "3",
    questionnaireName: "First Data Questionnaire",
    createAt: "11/17/23",
    lastModifiedAt: "04/15/24",
    categories: 3,
    questions: 1,
    documents: 28,
    mappingId: undefined
  },
  {
    questionnaireId: "4",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    categories: 1,
    questions: 13,
    documents: 4,
    mappingId: undefined
  },
  {
    questionnaireId: "5",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    categories: 1,
    questions: 13,
    documents: 4,
    mappingId: undefined
  },
]

export const documentData: IDocumentModel[] = [
  {
    documentId: "3173b614-c2db-4b56-a329-9333d10bbdda",
    documentName: "Merchant_Card_Processing.pdf",
    questionnaireName: "TSYS Application",
    createAt: "05/13/23",
    lastModifiedAt: "07/21/24",
    verifiedFields: 13,
    totalFields: 30,
  },
  {
    documentId: "3173b614-c2db-4b56-a329-9333d10bbdda",
    documentName: "Corporate_bylaws.pdf",
    questionnaireName: "General Application",
    createAt: "01/04/24",
    lastModifiedAt: "07/21/24",
    verifiedFields: 12,
    totalFields: 12,
  },
  {
    documentId: "3173b614-c2db-4b56-a329-9333d10bbdda",
    documentName: "Sample Processing Statement.pdf",
    questionnaireName: "First Data Questionnaire",
    createAt: "11/17/23",
    lastModifiedAt: "04/15/24",
    verifiedFields: 18,
    totalFields: 18,
  },
  {
    documentId: "3173b614-c2db-4b56-a329-9333d10bbdda",
    documentName: "Merchant Articles of Incorporation.pdf",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    verifiedFields: 16,
    totalFields: 32,
  },
  {
    documentId: "5",
    documentName: "Corporate_Resolution.pdf",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    verifiedFields: 8,
    totalFields: 14,
  },
  {
    documentId: "6",
    documentName: "Standard 2024 Tax Return.pdf",
    questionnaireName: "TSYS Application",
    createAt: "05/13/23",
    lastModifiedAt: "07/21/24",
    verifiedFields: 14,
    totalFields: 14,
  },
  {
    documentId: "7",
    documentName: "Standard 2023 Tax Return.pdf",
    questionnaireName: "General Application",
    createAt: "01/04/24",
    lastModifiedAt: "07/21/24",
    verifiedFields: 9,
    totalFields: 9,
  },
  {
    documentId: "8",
    documentName: "Voided_Check.pdf",
    questionnaireName: "First Data Questionnaire",
    createAt: "11/17/23",
    lastModifiedAt: "04/15/24",
    verifiedFields: 15,
    totalFields: 16,
  },
  {
    documentId: "9",
    documentName: "Bank Acct Verification.pdf",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    verifiedFields: 26,
    totalFields: 26,
  },
  {
    documentId: "10",
    documentName: "Merchant Statement of Good Standing.pdf",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    verifiedFields: 4,
    totalFields: 4,
  },
  {
    documentId: "11",
    documentName: "Merchant Return Policy.pdf",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    verifiedFields: 9,
    totalFields: 11,
  },
  {
    documentId: "12",
    documentName: "Standard 2022 Tax Return.pdf",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    verifiedFields: 13,
    totalFields: 30,
  },
]

export const mappingData: IMappingModel[] = [
  {
    mappingId: "1",
    mappingName: "TSYS",
    questionnaireName: "TSYS Application",
    createAt: "05/13/23",
    lastModifiedAt: "07/21/24",
    connections: 132,
  },
  {
    mappingId: "2",
    mappingName: "Merchant Owner Information",
    questionnaireName: "General Application",
    createAt: "01/04/24",
    lastModifiedAt: "07/21/24",
    connections: 256,
  },
  {
    mappingId: "3",
    mappingName: "FiServ First Data",
    questionnaireName: "First Data Questionnaire",
    createAt: "11/17/23",
    lastModifiedAt: "04/15/24",
    connections: 104,
  },
  {
    mappingId: "4",
    mappingName: "Processing Methods",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    connections: 79,
  },
  {
    mappingId: "5",
    mappingName: "Business Documents",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    connections: 14,
  },
  {
    mappingId: "6",
    mappingName: "Merchant Structure",
    questionnaireName: "TSYS Application",
    createAt: "05/13/23",
    lastModifiedAt: "07/21/24",
    connections: 14,
  },
  {
    mappingId: "7",
    mappingName: "General Data",
    questionnaireName: "General Application",
    createAt: "01/04/24",
    lastModifiedAt: "07/21/24",
    connections: 79,
  },
  {
    mappingId: "8",
    mappingName: "ACH Bank Information",
    questionnaireName: "First Data Questionnaire",
    createAt: "11/17/23",
    lastModifiedAt: "04/15/24",
    connections: 16,
  },
  {
    mappingId: "9",
    mappingName: "Supplement Information",
    questionnaireName: "Internet-Mail Order/Phone Order (MOTO)",
    createAt: "05/13/23",
    lastModifiedAt: "03/18/24",
    connections: 26,
  },
  {
    mappingId: "10",
    mappingName: "Pricing Methods",
    questionnaireName: "Organization",
    createAt: "05/15/23",
    lastModifiedAt: "03/06/24",
    connections: 4,
  },
]

  
